import css from './css.module.less';
import React from 'react';
import ErrorBoundary from 'src/components/ErrorBoundary';

const ModalContent = (props) => {
  const { style, children } = props;
  return (
    <div className={css.container} style={style || {}}>
      {children}
    </div>
  );
};
export default ErrorBoundary(ModalContent);
